import { render, staticRenderFns } from "./Statments.vue?vue&type=template&id=7ad86dc8"
import script from "./Statments.vue?vue&type=script&lang=js"
export * from "./Statments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports